<template>
    <div class="course-tabs pt-4">
        <b-tabs v-model="tabIndex" :style="borderStyles">
            <b-tab v-for="(tabItem, index) in tabs"
                   :style="borderStyles"
                   :title="titleTab(tabItem.title)"
                   :active="index === 0">
                   
            <div v-if="tabItem.title=='About'">
            
            	<svg v-if="course.coursemanagers.length>0" width="28" height="28" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            		<g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Template-1-/-Course-Info" transform="translate(-83 -1118)" fill="#383838"><g id="TABS-INFO" transform="translate(-87 1038)"><g id="About-Info" transform="translate(0 78)"><g id="icon/misc/question" transform="translate(168.077)"><path d="M12.873 25.333H4.667a2 2 0 01-2-2V4.667a2 2 0 012-2h22.666a2 2 0 012 2v18.666a2 2 0 01-2 2h-8.272l-2.506 3.707a.667.667 0 01-1.1.007l-2.582-3.714zm5.282-1.04a.667.667 0 01.552-.293h8.626a.667.667 0 00.667-.667V4.667A.667.667 0 0027.333 4H4.667A.667.667 0 004 4.667v18.666c0 .369.298.667.667.667h8.554c.219 0 .423.107.548.286l2.226 3.202 2.16-3.195zm-3.048-7.946c-.08-.52-.064-.99.05-1.41.113-.42.27-.807.47-1.16.2-.354.43-.684.69-.99.26-.307.503-.61.73-.91.226-.3.416-.604.57-.91.153-.307.23-.64.23-1 0-.534-.164-.99-.49-1.37-.327-.38-.81-.57-1.45-.57-.44 0-.857.103-1.25.31-.394.206-.744.49-1.05.85l-.94-.86c.426-.48.923-.877 1.49-1.19.566-.314 1.216-.47 1.95-.47 1.013 0 1.823.283 2.43.85.606.566.91 1.35.91 2.35 0 .44-.08.84-.24 1.2-.16.36-.357.7-.59 1.02-.234.32-.48.636-.74.95-.26.313-.5.636-.72.97-.22.333-.39.69-.51 1.07a3.04 3.04 0 00-.1 1.27h-1.44zm.76 4.2c-.334 0-.614-.117-.84-.35-.227-.234-.34-.53-.34-.89 0-.387.113-.697.34-.93.226-.234.506-.35.84-.35.333 0 .616.116.85.35.233.233.35.543.35.93 0 .36-.117.656-.35.89-.234.233-.517.35-.85.35z" id="Combined-Shape"/>
            		</g></g></g></g></g>
            	</svg>
            	<b v-if="course.coursemanagers.length>0">{{t('Do you have questions about this event? Contact us:')}}</b>
            	
            	<div v-if="course.coursemanagers.length>0" class="mt-3 mb-4">
            		<div class="row">
            			<div class="col-sm ml-5" v-for="manager in course.coursemanagers">
		            		<div class="cmquestion mr-2">
		            			<img :src="manager.profile_picture ? '/files/profile/'+manager.profile_picture : '/webroot/images/user_placeholder.jpg'" 
                                 width="48" height="48"
                                 alt="cmpic" class="img-circle mr-3">
		            		
		            		</div>
		            		<div>
			            		<p class="mb-0">{{manager.name}} {{manager.lastname}}</p>
			            		<span class="small"><a class="app-a" v-bind:href="'mailto:' + manager.email">{{manager.email}}</a></span><br/>
			            		<span class="small">{{manager.people_work_phone}}</span>
			            	</div>
			            </div>
			       	</div>
            	</div>
            	
            	<div v-if="course.hosts.length>0" class="mb-4">
            		<b>{{t('This event features:')}}</b>
            		<span v-for="(host , index) in course.hosts">{{host.category_name}}<template v-if="index+1 < course.hosts.length">, </template></span>
            	</div>
            
            
            </div>
                   
                <div :style="borderStyles"
                     v-html="tabItem.body" v-if="tabItem.body && tabItem.type === 'html'"></div>
                <ul class="list-unstyled"
                    :style="borderStyles"
                    v-if="tabItem.body && tabItem.type === 'list'">
                    <li :style="borderStyles"
                        v-for="(listItem, index) in tabItem.body">
                        {{listItem.text}}
                    </li>
                </ul>
                <div :style="borderStyles"
                     v-if="tabItem.body && tabItem.type === 'json'">{{tabItem.body.people_about}}</div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: "TabsPanel",
    props: {
        tabs: {
            type: Array
        },
        course: {
        	type: Object
        },
        tabIndex: {
        	type: Number
        }
    },
    methods:{
        titleTab(itemTitle){
          itemTitle = itemTitle.replace("About", this.t("About"));
          itemTitle = itemTitle.replace("What is needed for this course", "What is needed for this event");
          itemTitle = itemTitle.replace("What is needed for this event", this.t("What is needed for this event"));
          itemTitle = itemTitle.replace("Additional Information", this.t("Additional Information"));
          itemTitle = itemTitle.replace("Who is this for", this.t("Who is this for"));

          return itemTitle
        },
    },
    computed: {
        borderStyles() {
            let styles = {};
            const filterColors = _.get(this.$parent, 'corporation.color_filters', null);

            if (filterColors) {
                styles.borderColor = filterColors;
            }

            return styles;
        },
    }
}
</script>

<style scoped>

</style>

